import { apiClient } from '../client';
import type {
  ApiLocation,
  LocationRow,
  LocationShowResponse,
  LocationsListParams,
  LocationsListResponse,
} from './types';

export const locationsQueryKeys = {
  all: ['locations'] as const,
  lists: () => [...locationsQueryKeys.all, 'list'] as const,
  list: (params?: LocationsListParams) => [...locationsQueryKeys.lists(), params] as const,
  detail: (id: number) => [...locationsQueryKeys.all, 'detail', id] as const,
};

export async function getLocations(
  params?: LocationsListParams,
): Promise<LocationsListResponse> {
  const response = await apiClient.get<LocationsListResponse>('/api/locations', { params });
  return response.data;
}

// Single-location fetch for the edit page (GRAIN-1930). Returns the full
// `ApiLocation` — including `location_configs` with their ids, which the edit
// form needs to build `_destroy` tombstones on save. Deliberately does NOT go
// through `mapApiLocationToRow` (that strips config ids for the list).
export async function getLocation(id: number): Promise<LocationShowResponse> {
  const response = await apiClient.get<LocationShowResponse>(`/api/locations/${id}`);
  return response.data;
}

// Single seam where the wire shape becomes the UI row: `location_configs`
// objects map to the {config_type, notes} subset the cell renders (same
// pattern as the preset-menus `form` → `format` rebind). The serializer
// already orders configs by config_type, so no client re-sort. Config ids
// are dropped deliberately — the list only renders type + notes; the edit
// flow (GRAIN-1930) fetches its own detail payload.
export function mapApiLocationToRow(api: ApiLocation): LocationRow {
  return {
    id: api.id,
    postal_code: api.postal_code,
    notes: api.notes,
    configs: api.location_configs.map((config) => ({
      config_type: config.config_type,
      notes: config.notes,
    })),
  };
}
